import axios from "axios";

const returnUrl = "/v2/api/returns";

class ReturnService {
    static getReturns(urlP) {
        return new Promise(async (resolve, reject) => {
            try {
                let url = [returnUrl].join("");
                url = url + urlP;
                const result = await axios.get(url);
                const pagingData = result.data;
                resolve(pagingData);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static getReturnById(returnId) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${returnUrl}/${returnId}`;
                const result = await axios.get(url);
                const data = result.data;
                resolve(data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static createReturn(returnData) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${returnUrl}`;
                const result = await axios.post(url, returnData);
                const created = result.data;
                resolve(created);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static updateReturn(returnId, updatedData) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${returnUrl}/${returnId}`;
                await axios.put(url, updatedData);
                resolve(`Return record with ID ${returnId} updated successfully`);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static issueLabel(returnId) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${returnUrl}/${returnId}/label`;
                const result = await axios.post(url);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static getLabelRecipients(returnId) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${returnUrl}/${returnId}/label/recipients`;
                const result = await axios.get(url);
                resolve(result.data.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static sendLabel(returnId, recipient) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${returnUrl}/${returnId}/label/send`;
                const result = await axios.post(url, recipient);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static getTimeline(returnNo) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/v2/api/return-timeline/${encodeURIComponent(returnNo)}`;
                const result = await axios.get(url);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static deleteReturn(returnId) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `${returnUrl}/${returnId}`;
                await axios.delete(url);
                resolve(`Return record with ID ${returnId} deleted successfully`);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static uploadDocuments(files, returnId) {
        return new Promise(async (resolve, reject) => {
            try {
                const filesToUpload = files.map((file) => ({
                    filename: file.name,
                    content_type: file.content_type,
                    visibility: "Internal",
                    category: "returns",
                    name: file.name,
                    unique_id: file.unique_id,
                    requires_thumbnail: file.requires_thumbnail !== undefined ? file.requires_thumbnail : false,
                    document_role: file.document_role !== undefined ? file.document_role : 'attachment',
                }));
                const returnDocumentUrl = `${returnUrl}/${returnId}/documents`;
                const result = await axios.post(returnDocumentUrl, filesToUpload);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static async getReturnDocuments(returnId, documentRole) {
        try {
            const returnDocumentUrl = `${returnUrl}/${returnId}/documents`;
            const urlWithRole = documentRole ? `${returnDocumentUrl}?document_role=${encodeURIComponent(documentRole)}` : returnDocumentUrl;
            const result = await axios.get(urlWithRole);
            return result.data;
        } catch (error) {
            throw error;
        }
    }

    static async deleteReturnDocuments(returnId, documentIds) {
        try {
            const returnDocumentUrl = `${returnUrl}/${returnId}/documents`;
            await axios.delete(returnDocumentUrl, {
                data: documentIds,
                headers: { "Content-Type": "application/json" },
            });
        } catch (error) {
            throw error;
        }
    }
}

export default ReturnService;